import React from 'react';
import { SupervisedUserCircle } from '@mui/icons-material';
import { Divider, Box, styled } from '@mui/material';
import { match } from 'ts-pattern';
import Page from 'components/new/Page';
import VerticalTabs from 'components/new/VerticalTabs';
import { useVerticalTabs } from 'components/new/VerticalTabs/useVerticalTabs';
import Users from './Users';
import Roles from './Roles';
import {
  UserManagementNavigationContextProvider,
  useUserManagementNavigationContext,
} from './UserManagementNavigationContext';

enum UserManagementTab {
  Users = 'users',
  Roles = 'roles',
}

const ContentContainer = styled(Box)({
  flex: 1,
});

const UserManagementContent: React.FC = () => {
  const { openAddUserDrawer } = useUserManagementNavigationContext();
  const { selectedTab, setSelectedTab } = useVerticalTabs<UserManagementTab>(
    UserManagementTab.Users,
  );

  const tabs = [
    {
      label: 'Users',
      id: UserManagementTab.Users,
    },
    {
      label: 'Roles',
      id: UserManagementTab.Roles,
    },
  ];

  return (
    <Page
      heading="User management"
      spacing="lg"
      headingIcon={SupervisedUserCircle}
      actions={
        selectedTab === UserManagementTab.Users
          ? [
              {
                label: 'Add user',
                variant: 'contained',
                onClick: openAddUserDrawer,
              },
            ]
          : []
      }
    >
      <Divider />
      <VerticalTabs
        tabs={tabs}
        selectedTab={selectedTab as UserManagementTab}
        onTabChange={setSelectedTab}
        renderContent={(tab) => (
          <ContentContainer>
            {match(tab)
              .with(UserManagementTab.Users, () => <Users />)
              .with(UserManagementTab.Roles, () => <Roles />)
              .otherwise(() => (
                <></>
              ))}
          </ContentContainer>
        )}
      />
    </Page>
  );
};

const UserManagement: React.FC = () => {
  return (
    <UserManagementNavigationContextProvider>
      <UserManagementContent />
    </UserManagementNavigationContextProvider>
  );
};

export default UserManagement;
